import { useMutation } from "@apollo/client";

import { PlannerV2ScheduleCancelDocument } from "../mutations.generated";
import { PlannerV2AreasGetWithPendingChangesDocument } from "../queries.generated";

export default function usePlannerV2ScheduleCancel() {
    const [mutate, { data, loading, error }] = useMutation(PlannerV2ScheduleCancelDocument, {
        refetchQueries: [PlannerV2AreasGetWithPendingChangesDocument],
        awaitRefetchQueries: true,
    });

    return {
        /**
         * Cancels (rolls back) pending schedule changes. Omit `plannerVisitIds`
         * to cancel everything; pass a non-empty array to cancel only those visits.
         */
        cancelSchedule: async (plannerVisitIds?: string[]) => {
            await mutate({ variables: { input: plannerVisitIds ? { plannerVisitIds } : null } });
        },
        data,
        loading,
        error,
    };
}
